window.addEventListener('DOMContentLoaded', () => {
  const selector = '.mhxw';
  const selectorString = selector.split('.')[1];
  const modules = document.querySelectorAll(selector);

  modules.forEach(module => {
    const container = module.querySelector(`${selector}-items`);
    const config = {
      columns: {
        mobile: container.getAttribute('data-mobile-columns'),
        tablet: container.getAttribute('data-tablet-columns'),
        desktop: container.getAttribute('data-desktop-columns'),
      }
    };

    if (config.columns.desktop > 1) {
      $(container).slick({
        appendArrows: module.querySelector(`${selector}-nav`),
        prevArrow: `<button class="${selectorString}-nav_prev"><img src="/assets/img/icon-testimonial-prev.svg"/></button>`,
        nextArrow: `<button class="${selectorString}-nav_next"><img src="/assets/img/icon-testimonial-next.svg"/></button>`,
        responsive: [
          {
            breakpoint: 999999,
            settings: {
              infinite: true,
              autoplay: false,
              autoplaySpeed: 1000,
              slidesToScroll: 1,
              arrows: false,
              slidesToShow: config.columns.desktop,
            },
          },
          {
            breakpoint: 1025,
            settings: {
              arrows: (config.columns.desktop > config.columns.tablet) ? true : false,
              slidesToShow: config.columns.tablet,
            },
          },
          {
            breakpoint: 769,
            settings: {
              arrows: (config.columns.tablet > 1) ? true : false,
              slidesToShow: config.columns.mobile,
            },
          },
        ],
      });
    }
  });
});